import script from "./ConnectPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectPage.vue?vue&type=script&setup=true&lang=js"

import "./ConnectPage.vue?vue&type=style&index=0&id=9f4d2354&scoped=true&lang=css"

import exportComponent from "/Users/muhammadaziziabdulaziz/Documents/VueProject/reeqzan/transfers/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f4d2354"]])

export default __exports__